<template>
    <nav class="nav max-w-screen-xl mx-auto o">
        <div class="lg:mx-auto lg:flex lg:items-center lg:justify-between">
            <div class="flex justify-between items-center">
                <router-link to="/" class="inline-block">
                    <img src="../../assets/images/logo.svg" class="h-10 md:h-auto" alt="Goldenrace Foundation" />
                    <span class="sr-only">Goldenrace Foundaion</span>
                </router-link>
                <div class="lg:hidden">
                    <img src="../../assets/images/menu.svg" class="h-4 md:h-auto" alt="Menu Icon" />
                </div>
            </div>
            <div class="hidden lg:block">
                <router-link to="/privacy" class="a text-primary uppercase">Privacy Policy</router-link>
                <router-link to="/terms" class="a ml-10 text-primary uppercase">Terms & Conditions</router-link>
                <router-link to="/" class="ml-10"><Button name="Back to Home" /></router-link>
            </div>
        </div>
    </nav>
</template>

<script>
import Button from '../Button';

export default {
    components: {
        Button
    }
};
</script>

<style scoped>
    .nav {
        padding: 1.5rem 1.5rem 0 1.5rem;
    }

    .a {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 170%;
        text-align: right;
        letter-spacing: 0.4px;
    }
</style>